import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService, HttpParamsOptions } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare const $: any;
import { debounceTime } from "rxjs/operators";
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { password_validation } from './../../../shared/constants';
import { Config } from 'datatables.net';

class DataTablesResponse {
	res!: any[];
	draw!: number;
	filtercount!: number;
	count!: number;
}

@Component({
	selector: 'app-question-translation',
	templateUrl: './question-translation.component.html',
	styleUrl: './question-translation.component.css'
})
export class QuestionTranslationComponent implements OnInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/question-translation",
			name: "Question Translation"
		}
	];
	baseURL = environment.API_URL;
	dtOptions: Config = {};
	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dataList: any = [];
	allCategories: any[] = [];
	filter: any = {
		category: null
	}
	start: any;
	showLoader = false;

	constructor(private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute, private location: Location, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.getCategoriesList();
			this.getList();
		});
	}

	getCategoriesList() {
		this.apiService.getAllCategoryList().subscribe({
			next: (data: any) => {
				this.allCategories = data.data.map((s) => {
					s["id"] = parseInt(s["id"]);
					return s;
				});;
			}, error: (error) => {
				this.allCategories = [];
				this.toastr.error("Unable to fetch category list.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getList() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: true,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				this.start = parseInt(dataTablesParameters.start);
				let data: any = {
					"search": dataTablesParameters.search.value,
					"draw": dataTablesParameters.draw,
					"start": dataTablesParameters.start,
					"length": dataTablesParameters.length
				};
				if (this.filter.category) {
					data["category"] = this.filter.category;
				}
				const httpParams: HttpParamsOptions = { fromObject: data } as HttpParamsOptions;
				const options = { params: new HttpParams(httpParams) };
				this.http.get<DataTablesResponse>(this.baseURL + "getQuestionsFromProfile", options).subscribe({
					next: (resp) => {
						this.dataList = resp.res;
						callback({
							recordsTotal: resp.count,
							recordsFiltered: resp.filtercount,
							res: []
						});
					}, error: (error) => {
						this.dataList = [];
					}
				});
			},
			columns: [
				{ data: 'que_id' },
				{ data: 'question_name' },
				{ data: 'translation' }
			]
		};
	}

	refreshTable() {
		if (this.datatableElement) {
			this.datatableElement.dtInstance.then((dtInstance) => {
				dtInstance.draw();
			});
		}
	}

	save_translation() {
		/* let payload = {
			category: this.filter.category,
			questions: this.dataList
		};
		this.showLoader = true;
		this.apiService.bulkCreateQuestionBank(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.showLoader = false;
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}); */
	}
}
